import { createContext, useContext } from "react";
import type { Task } from "@common/types/task";

/**
 * How List opens a task: its row click's path, which also drops a `taskId`
 * deep link from the URL so the address follows the open task. Cells that
 * open a task (the blocked badge, row actions) use it instead of selecting
 * the task directly.
 */
export const TaskListOpenTaskContext = createContext<
    ((task: Task) => void) | null
>(null);

export const useTaskListOpenTask = () => {
    const openTask = useContext(TaskListOpenTaskContext);
    if (openTask === null) {
        throw new Error("useTaskListOpenTask must be used inside TasksList");
    }
    return openTask;
};
